import { Box, Flex, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import FacebookIcon from "~/components/icons/facebook";
import LinkedInIcon from "~/components/icons/linked-in";
import TwitterIcon from "~/components/icons/twitter";
import For from "~/components/utilities/for";
import CTA from "./cta";
type FooterProps = {
  cta?: boolean;
};
const Footer = (props: FooterProps) => {
  return (
    <VStack bgColor={"#0D3050"} w="full" fontFamily={"'Inter', sans-serif"}>
      {props.cta && <CTA />}

      <Box height="1px" bgColor="rgba(240, 237, 236, 0.2)" w="full" />
      <Flex
        justifyContent={{ lg: "space-between" }}
        align={{ lg: "center", base: "start" }}
        gap={{ base: "16px" }}
        py={{ base: "32px" }}
        w="full"
        px={{ xl: "160px", lg: "24px", base: "16px" }}
        direction={{ lg: "row", base: "column-reverse" }}
        maxWidth={"1440px"}
      >
        <Text
          color="white"
          fontSize={{ lg: "18px", base: "14px" }}
          lineHeight={{ lg: "18px", base: "14px" }}
          letterSpacing={{ base: "0.02em" }}
        >
          &copy;2023 Advante, All rights reserved.
        </Text>
        <HStack spacing={6}>
          <For
            each={[
              ["twitter", "https://twitter.com/advanteco"],
              ["linkedIn", "https://www.linkedin.com/company/advanteco"],
              ["facebook", "https://www.facebook.com/advanteco"],
            ]}
          >
            {([social, url]) => {
              const SocialIcon = {
                twitter: TwitterIcon,
                facebook: FacebookIcon,
                linkedIn: LinkedInIcon,
              }[social];

              return (
                <Box
                  as="a"
                  role="navigation"
                  aria-label={`Go to advante's ${social} account`}
                  rel="noreferrer noopener"
                  href={url}
                  target="_blank"
                  display="flex"
                >
                  <Icon
                    as={SocialIcon}
                    fill="white"
                    color="white"
                    width={{
                      base: "20px",
                      lg: "24px",
                    }}
                    height={{
                      base: "20px",
                      lg: "24px",
                    }}
                  />
                </Box>
              );
            }}
          </For>
        </HStack>
      </Flex>
    </VStack>
  );
};

export default Footer;
